import { Grid, IconButton, Typography } from '@quillbot/design-system';
import CloseIcon from '@mui/icons-material/Close';
import { makeStyles } from '@mui/styles';
import React from 'react';
import { RootState } from '@Common/models/redux/store';
import { useSelector } from 'react-redux';

interface IPProps {
  onClose: Function;
  topLevelText: string | JSX.Element;
  limit: number;
  wordCount: number;
}

const useStyles = makeStyles((theme) => ({
  main: {
    paddingLeft: '10px',
    paddingTop: (props: any) => (props?.isExtension ? '5px' : ''),
    flexWrap: 'nowrap',
    justifyContent: 'center',
    position: 'relative',
    backgroundColor: theme.palette.error.dark,
    height: '100%',
    maxWidth: '350px',
    [theme.breakpoints.up(600)]: {
      padding: '5px 28px 5px 12px',
    },
  },
  charLimit: {
    color: theme.palette.error.main,
    alignItems: 'center',
    fontWeight: 600,
    fontSize: '13px',
  },
  closeIconButton: {
    position: 'absolute',
    padding: '0px',
    right: 5,
    top: 5,
    '&:hover': {
      color: theme.palette.text.primary,
    },
  },
  closeIcon: {
    fontSize: '1.25rem',
  },
  topLevelText: {
    fontSize: '13px',
    fontWeight: 400,
  },
}));

export default function LimitError(props: IPProps) {
  const isExtension = useSelector((state: RootState) => state.common.platform?.isExtension);
  const classes = useStyles({ isExtension });

  const closeItem = () => {
    props.onClose();
  };

  return (
    <Grid item className={classes.main}>
      <IconButton className={classes.closeIconButton} onClick={closeItem} size="large">
        <CloseIcon className={classes.closeIcon} />
      </IconButton>
      <Grid
        item
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <Typography className={classes.topLevelText}>{props.topLevelText}</Typography>
      </Grid>
      <Typography display="inline" variant="body2" className={classes.charLimit}>
        <b>{props.wordCount}</b>/{props.limit} Words
      </Typography>
    </Grid>
  );
}
